import { render } from "./recurring-payment-settings.vue?vue&type=template&id=a18d2e52&scoped=true"
import script from "./recurring-payment-settings.vue?vue&type=script&lang=js"
export * from "./recurring-payment-settings.vue?vue&type=script&lang=js"

import "./recurring-payment-settings.vue?vue&type=style&index=0&id=a18d2e52&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a18d2e52"]])

export default __exports__